import React from 'react';
import image from '../../assets/main-pic-1.jpg';
import background from '../../assets/back-welcome-img.jpg';
import background2x from '../../assets/back-welcome-img@2x.jpg';
import styles from '../../views/HomeScreen/Main/Main.module.sass';
import {BackImage, Preview, Wrapper} from './styled';

type PreviewBackgroundImageProps = {
  children: React.ReactNode;
  className?: string;
};
function PreviewBackgroundImage({children, className}: PreviewBackgroundImageProps) {
  return (
    <Preview className={className}>
      <BackImage
        className={styles.previewImage}
        src={image}
        srcSet={`${background} 1x, ${background2x} 2x`}
        alt="Main"
      />
      <Wrapper>{children}</Wrapper>
    </Preview>
  );
}

export {PreviewBackgroundImage};
